export default __webpack_public_path__ + "static/media/project3.cb52c547.webp";